import getImageUrl from '@configuratorware/configurator-frontendgui/App/Utils/getImageUrl';

export type FontRecord = {
  name: string;
  family?: string;
  isDefault?: boolean;
  regular?: boolean;
  /** Resolved URL set by core `receiveFonts` (preferred). */
  urlRegular?: string;
  urlBold?: string;
  urlItalic?: string;
  urlBoldItalic?: string;
  /** Raw API path – only present before `receiveFonts` transforms the list. */
  fileNameRegular?: string | null;
};

export function getFontUrl(font: FontRecord | null | undefined): string | null {
  if (!font) return null;
  if (font.urlRegular) return font.urlRegular;
  if (font.fileNameRegular) return getImageUrl(font.fileNameRegular);
  return null;
}

export function getDefaultFontRecord(fonts: FontRecord[]): FontRecord | null {
  if (!fonts.length) return null;
  return fonts.find((font) => font.isDefault) || fonts[0];
}

export function getFontFamilyName(font: FontRecord): string {
  return font.family || font.name;
}

export function findFontByFamily(fonts: FontRecord[], fontFamily: string): FontRecord | null {
  return (
    fonts.find((f) => f.name === fontFamily || f.family === fontFamily) || fonts[0] || null
  );
}
